import React from "react";
import { IconButton } from '@mui/material';
import { useMsal } from "@azure/msal-react";
import StateContext from "src/context/UserProvider";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 * Note the [useMsal] package 
 */

export const SignInButton = (): React.JSX.Element => {
    const { login } = StateContext();
    const { instance } = useMsal();

    const handleLogin = (loginType: string) => {
        if (loginType === "popup") {
            instance.loginPopup().catch((e) => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect().catch((e) => {
                console.log(e);
            });
        }
    };
    return (
        <IconButton onClick={ () => {login ? login() : handleLogin("popup");} }>Sign in</IconButton>
        // <IconButton onClick={ () => {login ? login() : handleLogin("redirect");} }>Sign in</IconButton>
    );
};
